import {
  PlatformError,
  isFieldSentinel,
  isServerTimestampSentinel,
} from '@djgg/core';

function isPlainObject(value: unknown): value is Record<string, unknown> {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) return false;
  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
}

/**
 * Resolve server timestamps before a value is serialized into JSONB.
 *
 * SQL can resolve a field directive for a real column, but a directive nested
 * inside a JSONB parameter has already become inert data. Recursing here keeps
 * nested records (notably `CreationVersion.buildTiming.acceptedAt`) aligned
 * with the DocStore contract and guarantees no atomic directive is silently
 * persisted where it cannot operate against stored state.
 */
export function resolveJsonSentinels(value: unknown, timestampMs: number): unknown {
  if (isServerTimestampSentinel(value)) return timestampMs;
  if (isFieldSentinel(value)) {
    throw new PlatformError('validation', 'atomic field operations are unsupported inside JSON values');
  }
  if (Array.isArray(value)) {
    return value.map((item) => resolveJsonSentinels(item, timestampMs));
  }
  if (isPlainObject(value)) {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, resolveJsonSentinels(item, timestampMs)]),
    );
  }
  return value;
}
